import React, { useId, useRef } from "react";
import "./DocumentHistory.css";
import { Button, FileText, CircleX } from "../ui";
import { useModalLayer } from "./modalHooks";

const getReasonLabel = (reason, ar) => {
  if (reason === "deleted") return ar ? "ملغاة" : "Deleted";
  if (reason === "replaced") return ar ? "مستبدلة" : "Replaced";
  return ar ? "نسخة سابقة" : "Previous version";
};

export const DocumentHistoryModal = ({
  open,
  title,
  history = [],
  lang = "ar",
  onClose,
  onOpenFile,
}) => {
  const titleId = useId();
  const dialogRef = useRef(null);
  useModalLayer(open, { containerRef: dialogRef, onEscape: onClose });

  if (!open) return null;

  const ar = lang === "ar";

  return (
    <div className="document-history-modal__backdrop" role="presentation" onMouseDown={onClose}>
      <div
        ref={dialogRef}
        className="document-history-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="document-history-modal__header">
          <div>
            <h3 id={titleId}>{ar ? "سجل النسخ السابقة" : "Previous versions history"}</h3>
            {title ? <p>{title}</p> : null}
          </div>
          <Button
            variant="danger"
            appearance="soft"
            icon={<CircleX size={16} />}
            onClick={onClose}
            aria-label={ar ? "إغلاق" : "Close"}
            title={ar ? "إغلاق" : "Close"}
          />
        </div>

        <div className="document-history-modal__list">
          {history.length ? (
            history.map((entry, index) => {
              const file = entry?.file || entry;
              const uploadedAt = file?.uploadedAt;
              const archivedAt = entry?.archivedAt;

              return (
                <div className="document-history-modal__item" key={entry?._id || file?.publicId || index}>
                  <span className="document-history-modal__icon">
                    <FileText size={20} />
                  </span>

                  <div className="document-history-modal__content">
                    <strong>{file?.originalName || (ar ? `نسخة سابقة ${index + 1}` : `Previous version ${index + 1}`)}</strong>
                    <span>{getReasonLabel(entry?.reason, ar)}</span>
                    {uploadedAt ? (
                      <small>
                        {ar ? "رُفعت بتاريخ" : "Uploaded on"} {new Date(uploadedAt).toLocaleDateString(ar ? "ar-SA" : "en-GB")}
                      </small>
                    ) : null}
                    {archivedAt ? (
                      <small>
                        {ar ? "أُرشفت بتاريخ" : "Archived on"} {new Date(archivedAt).toLocaleDateString(ar ? "ar-SA" : "en-GB")}
                      </small>
                    ) : null}
                  </div>

                  <Button
                    variant="primary"
                    appearance="soft"
                    onClick={() => onOpenFile?.(entry, index)}
                    disabled={!file}
                  >
                    {ar ? "عرض" : "View"}
                  </Button>
                </div>
              );
            })
          ) : (
            <div className="document-history-modal__empty">
              {ar ? "لا توجد نسخ سابقة." : "No previous versions are available."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
